import { FC, useRef, useState } from "react";
// import { MenuOptionValue, Result } from "../../services/types";
// import HeaderMenu from "./HeaderMenu";
import useOnClickOutside from "../../hooks/useOnclickOutside";
import { Lookup, MenuOptionValue } from "../../types";
import ArrowDown from "../icons/ArrowDown";
import ArrowDropDown from "../icons/ArrowDropDown";
import ArrowUp from "../icons/ArrowUp";
import Filter from "../icons/Filter";
import HeaderMenu, { FilterOptionsQuery } from "./HeaderMenu";
import styles from "./TH.module.css";

interface THProps {
  title: string;
  fieldName: string;
  showTitleHover?: string;
  order?: {
    by?: string;
    setBy: (fieldName: string, desc: boolean) => void;
    desc: boolean;
  };
  optionSuffix?: string;
  filters?: {
    getSelectedOptions: (fieldName: string) => Exclude<MenuOptionValue, Lookup>[];
    update: (fieldName: string, values: MenuOptionValue[]) => void;
    get: (fieldName: string) => FilterOptionsQuery;
  };
  formatter?: (value: MenuOptionValue) => string | undefined;
}

const TH: FC<THProps> = (props) => {
  const [show, setShow] = useState(false);
  const menuRef = useRef<HTMLTableCellElement>(null);

  useOnClickOutside(menuRef, () => setShow(false));

  const toggleOrder = (event: React.MouseEvent) => {
    if (props.order) {
      const desc = props.order.by == props.fieldName ? !props.order.desc : false;
      props.order.setBy(props.fieldName, desc);
      event.stopPropagation();
    }
  };

  const onClose = () => {
    setShow(false);
  };

  const openMenu = (event: React.MouseEvent<HTMLTableCellElement, MouseEvent>) => {
    if (props.order || props.filters) {
      event.stopPropagation();
      setShow(true);
    }
  };

  const setOrder = (desc: boolean) => {
    if (desc !== props.order?.desc || props.order?.by !== props.fieldName) props.order?.setBy?.(props.fieldName, desc);
  };

  const selectedOptions = props.filters?.getSelectedOptions(props.fieldName) ?? [];

  return (
    <th title={props.showTitleHover ? props.showTitleHover : ""} className={styles.th} onClick={openMenu} ref={menuRef}>
      <div className={styles.content}>
        {props.order || props.filters ? (
          <span className={styles.text} onClick={toggleOrder}>
            {props.title}
          </span>
        ) : (
          <span className={styles.text}>{props.title}</span>
        )}
        {props.order && (
          <>
            {props.order.by == props.fieldName && !props.order.desc && <ArrowUp />}
            {props.order.by == props.fieldName && props.order.desc && <ArrowDown />}
          </>
        )}
        {selectedOptions.length > 0 && <Filter />}

        {(props.filters || props.order) && (
          <div className={styles.dropDown}>
            <ArrowDropDown />
          </div>
        )}
      </div>

      {show && (
        <HeaderMenu
          optionSuffix={props.optionSuffix}
          fieldName={props.fieldName}
          title={props.title}
          onClose={onClose}
          setOrder={props.order ? (order) => setOrder(order === "DESC") : undefined}
          filters={props.filters ? { ...props.filters, selectedOptions } : undefined}
          formatter={props.formatter}
        />
      )}
    </th>
  );
};

export default TH;
